
<div class="p-card--content">

    @if (hasTowers) {

        <div>
            <div class="labels">
                <!-- etiquetas para seleccionar torre -->
                @for(torre of towers; track $index){
                    <button [ngClass]="{'select': torre.name==inputTower.name}" pButton type="button" class="p-button p-button-success" (click)="changeTower(torre)">Torre {{torre.name}}</button>
                }
                <p><br></p>
            </div>
            <div *ngIf="inputTower">
                <div class="edificio" *ngIf="inputTower.floors.length>0">
                    @if (inputTower['azotea']?.units?.length) {
                        <p>Piso {{inputTower['azotea'].number}}</p>
                        <ul>
                            <li [ngClass]="{'selected': selectFloor==inputTower['azotea'].number && selectApartment==unit && selectTower==inputTower.name}" [class.selected]="checkIfFloorIsSelected(inputTower['azotea'].number,unit,inputTower.name)" (click)="onSelect(inputTower['azotea'].number, unit, inputTower.name)" *ngFor="let unit of inputTower['azotea'].units">
                                {{ unit }}
                            </li>
                        </ul>
                        <div></div>
                    }
                    @for (piso of inputTower.floors.slice().reverse(); track $index) {
                        <p>Piso {{piso.number}}</p>
                        <ul>
                            <li [ngClass]="{'selected': selectFloor==piso.number && selectApartment==unit && selectTower==inputTower.name}" [class.selected]="checkIfFloorIsSelected(piso.number,unit,inputTower.name)" (click)="onSelect(piso.number, unit, inputTower.name)" *ngFor="let unit of piso.units; let i = index">
                                {{ unit }}
                            </li>
                        </ul>
                        <div></div>
                    }
                </div>
            </div>
        </div>
    }@else {
        <div class="edificio" *ngIf="floors.length>0">
            @if (azotea?.units?.length) {
                <p>Piso {{azotea.number}}</p>
                <ul>
                    <li [ngClass]="{'selected': selectFloor==azotea.number && selectApartment==unit}" [class.selected]="checkIfFloorIsSelected(azotea.number,unit)" (click)="onSelect(azotea.number, unit)" *ngFor="let unit of azotea.units">
                        {{unit}}
                    </li>
                </ul>
                <div></div>
            }
            @for (piso of floors.slice().reverse(); track $index) {
                <p>Piso {{piso.number}}</p>
                <ul>
                    <li [ngClass]="{'selected': selectFloor==piso.number && selectApartment==unit}" [class.selected]="checkIfFloorIsSelected(piso.number,unit)" (click)="onSelect(piso.number, unit)" *ngFor="let unit of piso.units; let i = index">
                        {{unit}}
                    </li>
                </ul>
                <div></div>
            }
        </div>
    }
</div>
<p-dialog
    [header]="modalHeader "
    [modal]="true"
    [(visible)]="showPopup"
    (onHide)="closeDialog()"
>
    @if(consorcistasInUnit){
        <ng-container >
            @if(consorcistasInUnit.length>1){
                <ul class="list" style="padding-left: 2rem; max-width: 500px;" >
                    @for(consorcista of consorcistasInUnit;track $index){
                        <li>
                            <p><b> Nombre:</b> {{consorcista.firstName}} {{consorcista.lastName}}</p>
                            <p><b>Rol de ocupación:</b> {{ _t('roles.' + consorcista.occupancyRole) || '-' }}</p>
                        </li>
                    }
                </ul>

            }@else{
                <p>No Hay Ocupantes</p>
            }
        <div class="flex gap-3 justify-content-center">
            <p-button
                label="Cerrar"
                size="small"
                severity="secondary"
                (click)="closeDialog()">
            </p-button>
        </div>
        </ng-container>
    }
</p-dialog>
